/* global debounce */

// Initialise and observe animate on scroll
if (document.body.classList.contains('cc-animate-enabled')) {
  if ('IntersectionObserver' in window && 'MutationObserver' in window) {
    const initAnimateOnScroll = () => {
      const animatableElems = document.querySelectorAll('[data-cc-animate]:not(.cc-animate-init)');
      if (animatableElems.length > 0) {
        const intersectionObserver = new IntersectionObserver((entries, observer) => {
          entries.forEach((entry) => {
            // In view and hasn't been animated yet
            if (entry.isIntersecting && !entry.target.classList.contains('cc-animate-in')) {
              const elem = entry.target;
              // Safari/iOS performance: Add will-change before animation starts
              elem.style.willChange = 'opacity';
              elem.classList.add('cc-animate-in');
              
              // Remove will-change after animation completes to free memory (Safari optimization)
              const duration = parseFloat(getComputedStyle(elem).animationDuration) * 1000 || 800;
              const delay = parseFloat(getComputedStyle(elem).animationDelay) * 1000 || 300;
              setTimeout(() => {
                elem.style.willChange = 'auto';
              }, duration + delay + 100);
              
              observer.unobserve(elem);
            }
          });
        });

        // Initialise and observe each animatable element
        animatableElems.forEach((elem) => {
          // Set the animation delay
          if (elem.dataset.ccAnimateDelay) {
            elem.style.animationDelay = elem.dataset.ccAnimateDelay;
          }

          // Set the animation duration
          if (elem.dataset.ccAnimateDuration) {
            elem.style.animationDuration = elem.dataset.ccAnimateDuration;
          }

          // Init the animation
          if (elem.dataset.ccAnimate) {
            elem.classList.add(elem.dataset.ccAnimate);
          }

          elem.classList.add('cc-animate-init');

          // Watch for elem
          intersectionObserver.observe(elem);
        });
      }
    };

    const aosMinWidth = getComputedStyle(document.documentElement)
      .getPropertyValue('--aos-min-width') || '0';
    const mq = window.matchMedia(`(min-width: ${aosMinWidth}px)`);
    if (mq.matches) {
      initAnimateOnScroll();

      // Check for more animatable elements when the DOM mutates
      // Safari performance optimization: Scope observer to main content, increase debounce
      document.addEventListener('DOMContentLoaded', () => {
        const debouncedInit = debounce(initAnimateOnScroll, 500); // Increased from 250ms for Safari
        const observer = new MutationObserver(debouncedInit);
        
        // Scope observer to main content area instead of entire body for better Safari performance
        const mainContent = document.getElementById('main-content') || document.body;
        observer.observe(mainContent, {
          subtree: true,
          childList: true
        });
      });
    } else {
      document.body.classList.remove('cc-animate-enabled');

      try {
        mq.addEventListener('change', (event) => {
          if (event.matches) {
            document.body.classList.add('cc-animate-enabled');
            setTimeout(initAnimateOnScroll, 100);
          }
        });
      } catch (e) {
        // Legacy browsers (Safari < 14), rely on the animations being shown by the line above the
        // try
      }
    }
  } else {
    // Reveal all the animations
    document.body.classList.remove('cc-animate-enabled');
  }
}
